import { Link } from "react-router-dom";
import { BRAND } from "../lib/site";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 pt-20 pb-8 overflow-hidden">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <div className="max-w-sm">
            <img src="/logo-mark.png" alt="Veni Vidi Vici mark" className="h-9 w-auto mb-5" />
            <div className="font-serif text-2xl">Vinci Inc.</div>
            <div className="font-grotesk text-[10px] uppercase tracking-[0.28em] text-[#8A8A82] mt-1">Crafted for Constructions</div>
            <p className="font-body text-sm text-[#8A8A82] mt-4 leading-relaxed">
              Bulk trading of world-class construction materials across Asia. {BRAND.motto}.
            </p>
          </div>
          <div className="flex gap-12">
            <div>
              <span className="overline text-[#8A8A82]">Navigate</span>
              <ul className="mt-4 space-y-2 font-body text-sm text-[#C9C9C2]">
                <li><a href="#about" className="hover:text-[#B87333] transition-colors">About</a></li>
                <li><a href="#services" className="hover:text-[#B87333] transition-colors">Services</a></li>
                <li><a href="#materials" className="hover:text-[#B87333] transition-colors">Materials</a></li>
                <li><a href="#projects" className="hover:text-[#B87333] transition-colors">Projects</a></li>
                <li><Link to="/careers" data-testid="footer-careers" className="hover:text-[#B87333] transition-colors">Careers</Link></li>
              </ul>
            </div>
            <div>
              <span className="overline text-[#8A8A82]">Contact</span>
              <ul className="mt-4 space-y-2 font-body text-sm text-[#C9C9C2]">
                <li><a href={`mailto:${BRAND.email}`} className="hover:text-[#B87333] transition-colors">{BRAND.email}</a></li>
                <li data-testid="footer-phone">Phone: <a href={`tel:${BRAND.phones[0].replace(/\s/g, "")}`} className="hover:text-[#B87333] transition-colors">{BRAND.phones[0]}</a> &nbsp;/&nbsp; <a href={`tel:${BRAND.phones[1].replace(/\s/g, "")}`} className="hover:text-[#B87333] transition-colors">{BRAND.phones[1]}</a></li>
                <li className="text-[#8A8A82] leading-relaxed max-w-xs">
                  {BRAND.address.company}<br />
                  {BRAND.address.city}, {BRAND.address.state} — {BRAND.address.pincode}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="font-serif leading-none text-transparent [-webkit-text-stroke:1px_rgba(245,245,240,0.14)] text-[clamp(4rem,22vw,20rem)] tracking-tighter select-none">
          VINCI
        </div>
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 pt-6 border-t border-white/10">
          <span className="font-body text-xs text-[#8A8A82]">© {new Date().getFullYear()} Vinci Inc. · Vinci Trade Asia. All rights reserved.</span>
          <div className="flex flex-wrap items-center gap-6">
            <Link to="/privacy" data-testid="footer-privacy" className="font-body text-xs text-[#8A8A82] hover:text-[#B87333] transition-colors">Privacy Policy</Link>
            <Link to="/terms" data-testid="footer-terms" className="font-body text-xs text-[#8A8A82] hover:text-[#B87333] transition-colors">Terms of Sale</Link>
            <Link to="/refund" data-testid="footer-refund" className="font-body text-xs text-[#8A8A82] hover:text-[#B87333] transition-colors">Refund Policy</Link>
            <Link to="/delivery" data-testid="footer-delivery" className="font-body text-xs text-[#8A8A82] hover:text-[#B87333] transition-colors">Shipping & Delivery</Link>
            <Link to="/accessibility" data-testid="footer-accessibility" className="font-body text-xs text-[#8A8A82] hover:text-[#B87333] transition-colors">Accessibility</Link>
            <span className="overline text-[#8A8A82]">{BRAND.motto}</span>
          </div>
        </div>
        <p data-testid="footer-fineprint" className="mt-4 text-[10px] leading-relaxed text-[#6f6f68] max-w-4xl">
          {BRAND.enquiry}
        </p>
      </div>
    </footer>
  );
};
